import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cloneDeep } from 'lodash';
import { Button, Form, FormGroup } from 'react-bootstrap';
import Pluralize from 'react-pluralize';
import { Typeahead } from 'react-bootstrap-typeahead';
import feedviewsActions from '../../../redux/feedviews/actions';
import feedsActions from '../../../redux/feeds/actions';
import ProdigyInput from '../../GlobalUI/ProdigyInput';
import '../Feedview.scss';

function FeedviewConfig(props) {
  const { feedview, feeds, actions, history } = props;
  const [availableFeeds, setAvailableFeeds] = useState([]);
  const [feedToAdd, setFeedToAdd] = useState([]);
  const [addedFeeds, setAddedFeeds] = useState([]);
  const [displayName, setDisplayName] = useState('');
  const [feedviewId, setFeedviewId] = useState(feedview.id);
  const [errors, setErrors] = useState({});
  let typeaheadInstance;

  useEffect(() => {
    actions.feedsRequest();
  }, [actions]);

  useEffect(() => {
    setAddedFeeds(feedview.Feeds);
    if (feedview.name) {
      setDisplayName(feedview.name);
    }
    if (feedview.id) {
      setFeedviewId(feedview.id);
    }
  }, [feedview]);

  const availableFeedFilter = currentFeed => {
    const found = feedview.Feeds.some(f => f.id === currentFeed.id);
    // if currentFeed id is found in feedview.Feeds
    // it is not available to be added again
    return !found;
  };

  useEffect(() => {
    const af = feeds.feeds.map(f => {
      f.label = !f.name ? f.id : f.name;
      return f;
    });
    setAvailableFeeds(af);
  }, [feeds.feeds]);

  const getAvailabelFeeds = () => {
    let af = cloneDeep(availableFeeds);
    if (feedview.Feeds.length > 0) {
      af = af.filter(availableFeedFilter);
    }
    return af;
  };

  const addSelectedFeedToFeedview = () => {
    feedview.Feeds.push(feedToAdd);
    setAddedFeeds(feedview.Feeds);
    setFeedToAdd([]);
  };

  const removeFeed = row => {
    const index = feedview.Feeds.findIndex(f => f.id === row.id);
    if (index > -1) {
      feedview.Feeds.splice(index, 1);
      const addedFeedsClone = cloneDeep(feedview.Feeds);
      setAddedFeeds(addedFeedsClone);
      setAvailableFeeds(feeds.feeds);
    }
  };

  const renderFeedRow = feed => (
    <div className="feed-row">
      <div className="feed-name">{feed.name}</div>
      <div className="feed-action">
        <button
          className="btn btn-primary"
          onClick={e => {
            removeFeed(feed);
            e.preventDefault();
          }}
        >
          Remove
        </button>
      </div>
    </div>
  );

  const validateForm = () => {
    const e = {};
    if (!feedviewId) {
      e.feedviewId = {
        msg: 'Feedview Id is Required',
      };
      setErrors(e);
      return false;
    }
    if (displayName === '') {
      e.displayName = {
        msg: 'Feedview Name is Required',
      };
      setErrors(e);
      return false;
    }
    setErrors(e);
    return true;
  };

  const cancel = () => {
    history.push('/feedviews/');
  };

  const submitForm = () => {
    if (validateForm()) {
      feedview.name = displayName;
      if (!feedview.id && feedviewId !== null) {
        feedview.id = feedviewId;
        feedview.where = [];
        actions.createFeedviewRequest({ feedview });
      } else {
        actions.modifyFeedviewRequest({ feedview });
      }
    }
  };

  return (
    <div className="feedview-tab-container">
      <Form className="feedview-config-tab-form">
        <FormGroup>
          <div className="row">
            <div className="field col-sm-6">
              <ProdigyInput
                value={feedviewId}
                label="ID"
                onChangeHandler={setFeedviewId}
                required
                error={errors.feedviewId}
                disabled={feedview.id}
              />
            </div>
            <div className="field col-sm-6">
              <ProdigyInput
                value={displayName}
                label="Name"
                onChangeHandler={setDisplayName}
                required
                error={errors.displayName}
              />
            </div>
          </div>

          <div className="row">
            <div className="field col-sm-6 add-feed-input-container">
              <div className="feed-typeahead-container">
                <label htmlFor="feed-typeahead">Add Feed to Feedview</label>
                <Typeahead
                  id="feed-typeahead"
                  ref={typeahead => {
                    typeaheadInstance = typeahead;
                  }}
                  placeholder="Add a Feed to this Feedview"
                  className="feedview-typeahead"
                  selectHintOnEnter
                  clearButton
                  filterBy={['id']}
                  value={feedToAdd}
                  options={getAvailabelFeeds()}
                  onChange={feed => setFeedToAdd(feed[0])}
                />
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={!feedToAdd || feedToAdd.length === 0}
                  onClick={() => {
                    addSelectedFeedToFeedview();
                    if (typeaheadInstance && typeaheadInstance.getInstance) {
                      typeaheadInstance.getInstance().clear();
                    }
                  }}
                >
                  Add &gt;
                </button>
              </div>
            </div>
            <div className="field col-sm-6">
              <label>
                <Pluralize
                  singular="Feed"
                  plural="Feeds"
                  count={feedview.Feeds.length}
                />
              </label>
              <div className="feedview-feeds-container">
                <div className="feed-header-row">
                  <div>Name</div>
                  <div className="feed-action">Actions</div>
                </div>
                <div>{addedFeeds.map(renderFeedRow)}</div>
              </div>
            </div>
          </div>
        </FormGroup>
        <div className="row submit-button-row">
          <div>
            <Button variant="secondary" type="button" onClick={() => cancel()}>
              Cancel
            </Button>
          </div>
          <div>
            <Button
              variant="primary"
              type="button"
              onClick={() => submitForm()}
            >
              Save Config
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
}

FeedviewConfig.propTypes = {
  feedview: PropTypes.object,
  feeds: PropTypes.object,
  actions: PropTypes.object,
  history: PropTypes.object,
};

const mapStateToProps = ({ feeds }) => ({ feeds });

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      ...feedviewsActions,
      ...feedsActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(FeedviewConfig);
